module.exports = "<p>\r\n  capacidad works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/capacidad/capacidad.component.html
// module id = ../../../../../src/app/components/capacidad/capacidad.component.html
// module chunks = main